module.exports = __webpack_public_path__ + "static/img/zgc_log.08b3d43.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/zgc_log.png
// module id = Ge9/
// module chunks = 0